if (!customElements.get('carousel-scrollbar')) {
  customElements.define('carousel-scrollbar', class extends HTMLElement {
    connectedCallback() {
      this.track = document.getElementById(this.getAttribute('aria-controls'));
      this.thumb = this.querySelector('span');
      if (!this.track || !this.thumb) return;
      this.refresh = () => {
        this.maximum = Math.max(0, this.track.scrollWidth - this.track.clientWidth);
        this.hidden = this.maximum < 1;
        this.fraction = Math.max(.05, Math.min(1, this.track.clientWidth / this.track.scrollWidth));
        const position = this.maximum ? Math.min(1, Math.abs(this.track.scrollLeft) / this.maximum) : 0;
        this.thumb.style.width = `${this.fraction * 100}%`;
        this.thumb.style.insetInlineStart = `${position * (1 - this.fraction) * 100}%`;
        this.setAttribute('aria-valuenow', String(Math.round(position * 100)));
      };
      this.moveTo = (position, dragging = false) => {
        const rtl = getComputedStyle(this.track).direction === 'rtl';
        this.track.scrollTo({ left: (rtl ? -1 : 1) * Math.max(0, Math.min(1, position)) * this.maximum, behavior: dragging || matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
      };
      this.pointerDown = (event) => {
        if (event.button !== 0) return;
        const thumbRect = this.thumb.getBoundingClientRect();
        if (event.target !== this.thumb) {
          const rect = this.getBoundingClientRect();
          let position = (event.clientX - rect.left - thumbRect.width / 2) / (rect.width - thumbRect.width);
          if (getComputedStyle(this.track).direction === 'rtl') position = 1 - position;
          this.moveTo(position);
          return;
        }
        this.dragOffset = event.clientX - thumbRect.left;
        this.previousSnap = this.track.style.scrollSnapType;
        this.track.style.scrollSnapType = 'none';
        this.setPointerCapture(event.pointerId);
        this.dragging = true;
        this.focus({ preventScroll: true });
        this.pointerMove(event);
        event.preventDefault();
      };
      this.pointerMove = (event) => {
        if (!this.dragging) return;
        const rect = this.getBoundingClientRect();
        const room = rect.width * (1 - this.fraction);
        let position = room ? (event.clientX - rect.left - this.dragOffset) / room : 0;
        if (getComputedStyle(this.track).direction === 'rtl') position = 1 - position;
        this.moveTo(position, true);
      };
      this.pointerEnd = () => {
        if (this.dragging) this.track.style.scrollSnapType = this.previousSnap;
        this.dragging = false;
      };
      this.keyDown = (event) => {
        let position = this.maximum ? Math.abs(this.track.scrollLeft) / this.maximum : 0;
        const step = this.maximum ? this.track.clientWidth / this.maximum : 1;
        const rtl = getComputedStyle(this.track).direction === 'rtl';
        if (event.key === 'Home') position = 0;
        else if (event.key === 'End') position = 1;
        else if (event.key === 'ArrowRight') position += rtl ? -step : step;
        else if (event.key === 'ArrowLeft') position += rtl ? step : -step;
        else return;
        event.preventDefault();
        this.moveTo(position);
      };
      this.track.addEventListener('scroll', this.refresh, { passive: true });
      this.addEventListener('pointerdown', this.pointerDown);
      this.addEventListener('pointermove', this.pointerMove);
      this.addEventListener('pointerup', this.pointerEnd);
      this.addEventListener('pointercancel', this.pointerEnd);
      this.addEventListener('keydown', this.keyDown);
      this.resize = new ResizeObserver(this.refresh);
      this.resize.observe(this.track);
      this.refresh();
    }
    disconnectedCallback() {
      this.pointerEnd?.();
      this.resize?.disconnect();
      this.track?.removeEventListener('scroll', this.refresh);
      this.removeEventListener('pointerdown', this.pointerDown);
      this.removeEventListener('pointermove', this.pointerMove);
      this.removeEventListener('pointerup', this.pointerEnd);
      this.removeEventListener('pointercancel', this.pointerEnd);
      this.removeEventListener('keydown', this.keyDown);
    }
  });
}
